import { Grid, Divider } from '@mui/material';
import ClipLoader from "react-spinners/ClipLoader";
import React, { Component } from 'react';
import { connect } from "react-redux";
import { startNextReview } from '../actions/NextReviewActions';
import { startReviewDecision } from '../actions/ReviewDecisionActions';
import { startLoading } from '../actions/LoadingActions';

const firstKey = "firstKey";
const secondKey = "secondKey"; 
const thirdKey = "thirdKey"; 

class ReviewPage extends Component {

    state = {
        firstAudioSrc: null,
        secondAudioSrc: null,
        thirdAudioSrc: null,
        playStates: {
            firstKey: false,
            secondKey: false,
            thirdKey: false
        }
    };

    constructor(props) {
        super(props);

        this.players = {
            firstKey: React.createRef(null),
            secondKey: React.createRef(null),
            thirdKey: React.createRef(null)
        }
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.changePlayerState = this.changePlayerState.bind(this);

        this.renderWithReview = this.renderWithReview.bind(this);
        this.renderRow = this.renderRow.bind(this);
        this.nextReview = this.nextReview.bind(this);
        this.renderAudioControl = this.renderAudioControl.bind(this);
        this.renderDecisionButtons = this.renderDecisionButtons.bind(this);
        this.reviewDecision = this.reviewDecision.bind(this);
        this.renderWithSongReview = this.renderWithSongReview.bind(this);
        this.renderWithBandPicture = this.renderWithBandPicture.bind(this);
        this.noneIfEmpty = this.noneIfEmpty.bind(this);

        this.fetchAudoWithRange = this.fetchAudoWithRange.bind(this);
        this.cleanUpBlob = this.cleanUpBlob.bind(this);
    }

    async componentDidUpdate(prevProps, prevState) {
        const { review } = this.props;
        if (review.songInfo != null && (prevProps.review.songInfo == null || prevProps.review.songInfo.url.url !== review.songInfo.url.url)) {
            this.cleanUpBlob(prevState.firstAudioSrc);
            const first = await this.fetchAudoWithRange(review.songInfo.url.url, review.samples.first);
            this.cleanUpBlob(prevState.secondAudioSrc);
            const second = await this.fetchAudoWithRange(review.songInfo.url.url, review.samples.second);
            this.cleanUpBlob(prevState.thirdAudioSrc);
            const third = await this.fetchAudoWithRange(review.songInfo.url.url, review.samples.third);
            this.setState({
                firstAudioSrc: first,
                secondAudioSrc: second,
                thirdAudioSrc: third
            });
        }
    }

    play(key) {
        this.players[key].current.play();
        this.changePlayerState(key, true);
    }

    pause(key) {
        this.players[key].current.pause();
        this.changePlayerState(key, false);
    }

    changePlayerState(key, state) {
        const newPlayStates = Object.assign({}, this.state.playStates);
        newPlayStates[key] = state;
        this.setState({
            playStates: newPlayStates
        });
    }

    renderPlayPause(key) {
        const { playStates, loading } = this.state;
        const isPlay = playStates[key];

        if (loading) {
            return (
                <ClipLoader color="#FFFFFF" sizeUnit={"%"} size={100} loading={true} />
            );
        } else if (!isPlay) {
            return (
                <img
                src="https://img.icons8.com/nolan/64/play.png"
                className="icon_button"
                onClick={() => this.play(key)}
                alt={"Play"}
                />
            );
        } else {
            return (
                <img
                src="https://img.icons8.com/nolan/64/pause.png"
                className="icon_button"
                onClick={() => this.pause(key)}
                alt={"Pause"}
                />
            );
        }
    }

    renderAudioControl(src, key) {
        return <React.Fragment>
            <audio
                ref={this.players[key]}
                src={`${src}`}
                type="audio/mp3"
            />
            {this.renderPlayPause(key)}
        </React.Fragment>
    }

    nextReview() {
        const { dispatch } = this.props;
        dispatch(startNextReview());
    }

    reviewDecision(accepted) {
        const { review, dispatch } = this.props;
        const uniqueName = review.info.uniqueName;
        dispatch(startLoading());
        dispatch(startReviewDecision(accepted, uniqueName, ""));
    }

    render() {
        const { review, attachedImageUrl } = this.props;
        return (
            <React.Fragment>
                <h1>Review</h1>
                {review.empty ? this.renderNextReviewButton() : this.renderWithReview(review, attachedImageUrl)}
            </React.Fragment>
        );
    }

    renderNextReviewButton() {
        const {loading} = this.props;
        return (
            <Grid container spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center">
                <Grid>
                    <button
                        id="startButton"
                        className="bbe-button"
                        disabled={loading}
                        onClick={this.nextReview}
                        >
                    Next Review
                    </button>
                </Grid>
            </Grid>
        )
    }

    renderWithReview(review, attachedImageUrl) {
        return (<Grid container>
                {review.info.reviewType === "SONG" ? this.renderWithSongReview(review) : this.renderWithBandPicture(review, attachedImageUrl)}
                <Grid item xs={12}>
                    {this.renderDecisionButtons()}
                </Grid>
        </Grid>)
    }

    noneIfEmpty(field) {
        return field === null || field.length === 0 ? "None" : field;
    }


    renderWithSongReview(review) {
        const {firstAudioSrc, secondAudioSrc, thirdAudioSrc} = this.state;
        return (
            <React.Fragment>
                <Grid item xs={12}>
                    <Divider spacing={1}><h2>Song Name</h2></Divider>
                </Grid>
                <Grid item xs={12}>
                    {this.renderRow("Discovered", this.noneIfEmpty(review.info.reviewState.title))}
                </Grid>
                <Grid item xs={12}>
                    {this.renderRow("User Given", review.songInfo.songName)}
                </Grid>
                <Grid item xs={12}>
                    <Divider spacing={1}><h2>Artist</h2></Divider>
                </Grid>
                <Grid item xs={12}>
                    {this.renderRow("Discovered", this.noneIfEmpty(review.info.reviewState.artist))}
                </Grid>
                <Grid item xs={12}>
                    {this.renderRow("User Band Name", review.songInfo.bandName)}
                </Grid>
                <Grid item xs={12}>
                    <Divider spacing={1}><h2>Label</h2></Divider>
                </Grid>
                <Grid item xs={12}>
                    {this.renderRow("Discovered Label", this.noneIfEmpty(review.info.reviewState.label), "", "")}
                </Grid>
                <Grid item xs={12}>
                    <Divider spacing={1}><h2>Song Samples</h2></Divider>
                </Grid>
                <Grid item xs={12}>
                    {this.renderAudioControl(firstAudioSrc, firstKey)}
                </Grid>
                <Grid item xs={12}>
                    {this.renderAudioControl(secondAudioSrc, secondKey)}
                </Grid>
                <Grid item xs={12}>
                    {this.renderAudioControl(thirdAudioSrc, thirdKey)}
                </Grid>
                <Grid item xs={12}>
                    <Divider spacing={1}><h2>Evidence</h2></Divider>
                </Grid>
                <Grid item xs={12}>
                   {review.attachedImageUrl ? <img
                        width={500}
                        height={500}
                        alt='Evidence_Picture'
                        src={review.attachedImageUrl}
                    /> : <React.Fragment/>}
                    
                </Grid>
                
            </React.Fragment>
        );
    }

    renderWithBandPicture(review, attachedImageUrl) {
        return <React.Fragment>
            <Grid item xs={12}>
                <Divider spacing={1}><h2>Band Picture</h2></Divider>
                <Grid item xs={12}>
                   {review.attachedImageUrl ? <img
                        width={500}
                        height={500}
                        alt='Band_Picture'
                        src={review.attachedImageUrl}
                    /> : <React.Fragment/>}
                    
                </Grid>
            </Grid>
        </React.Fragment>
    }

    renderDecisionButtons() {
        const {loading} = this.props;
        return <Grid container>
            <Grid item xs={6}>
                <button
                    id="acceptReviewButton"
                    className="bbe-button-accept"
                    disabled={loading}
                    onClick={() => this.reviewDecision(true)}
                    >
                Accept
                </button>
            </Grid>
            <Grid item xs={6}>
                <button
                    id="rejectReviewButton"
                    className="bbe-button-reject"
                    disabled={loading}
                    onClick={() => this.reviewDecision(false)}
                    >
                Reject
                </button>
            </Grid>
        </Grid>
    }

    async fetchAudoWithRange(songUrl, sample) {
        const { dispatch } = this.props;
        try {
            const response = await fetch(songUrl, {
                headers: {
                    'Range': `bytes=${sample.start}-${sample.end}`
                }
            });
            
            if (!response.ok) {
                throw new Error('Failed to fetch audio');
            }
            
            const audioBlob = await response.blob();
            const blobUrl = URL.createObjectURL(audioBlob);
            
            return blobUrl
        
        } catch (error) {
            console.error('Error fetching audio:', error);
            dispatch(reportError("Unable to load song"));
        }
    }

    cleanUpBlob(blob) {
        if (blob) {
            URL.revokeObjectURL(blob);
        }
    }

    renderRow(name, value) {
        return (
            <Grid container direction="row">
                <Grid item xs={6}>
                    <h2>{name}:</h2>
                </Grid>
                <Grid item xs={6}>
                    <h2>{value}</h2>
                </Grid>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => ({
    loading: state.loading.loading,
    review: state.review,
    attachedImageUrl: state.attachedImageUrl
});

export default connect(mapStateToProps)(ReviewPage)